// @flow

/* Категории */
export const OSAGO_FEEDBACK_CATEGORY = 1;
export const KASKO_FEEDBACK_CATEGORY = 2;
export const FLAT_FEEDBACK_CATEGORY = 5;
export const VZR_FEEDBACK_CATEGORY = 45;
export const MITE_FEEDBACK_CATEGORY = 49;
export const RF_FEEDBACK_CATEGORY = 51;
export const LK_FEEDBACK_CATEGORY = 90;

/* Подкатегории */

/* Осаго */
export const OSAGO_CANT_GET_POLICY_FEEDBACK_SUBCATEGORY = 1001;
export const OSAGO_WANT_TO_MAKE_CHANGES_FEEDBACK_SUBCATEGORY = 1002;
export const OSAGO_PAYMENT_ERROR_FEEDBACK_SUBCATEGORY = 1003;
export const OSAGO_RSA_CHECK_DIDNT_PASSED_FEEDBACK_SUBCATEGORY = 1004;
export const OSAGO_KBM_FEEDBACK_SUBCATEGORY = 1005;
export const OSAGO_DIAGNOSTIC_CARD_FEEDBACK_SUBCATEGORY = 1006;
export const OSAGO_CANT_LOAD_DATA_FEEDBACK_SUBCATEGORY = 1007;
export const OSAGO_OTHER_OBSOLETE_SUBCATEGORY = 1008;
export const OSAGO_INCORRECT_PREFILL_FEEDBACK_SUBCATEGORY = 1009;

export const OSAGO_CHANGES_PLOBLEMS_FEEDBACK_SUBCATEGORY = 1011;
export const OSAGO_PAYMENT_PLOBLEMS_FEEDBACK_SUBCATEGORY = 1012;
export const OSAGO_DELIVERY_TO_EMAIL_PLOBLEMS_FEEDBACK_SUBCATEGORY = 1013;
export const OSAGO_OFFERED_TO_RSA_FEEDBACK_SUBCATEGORY = 1014;
export const OSAGO_INSURANCE_CASE_FEEDBACK_SUBCATEGORY = 1015;
export const OSAGO_ADRESS_PLOBLEMS_FEEDBACK_SUBCATEGORY = 1016;
export const OSAGO_EXPERIECE_OR_AGE18_FEEDBACK_SUBCATEGORY = 1017;
export const OSAGO_LK_ERROR_FEEDBACK_SUBCATEGORY = 1018;
export const OSAGO_RUNTIME_FEEDBACK_SUBCATEGORY = 1019;
export const OSAGO_UPLOAD_SCANS_PROBLEMS_FEEDBACK_SUBCATEGORY = 1020;
export const OSAGO_PAPER_POLICY_NOT_FOUND_FEEDBACK_SUBCATEGORY = 1021;
export const OSAGO_ENTERING_DATA_PROBLEMS_FEEDBACK_SUBCATEGORY = 1022;
export const OSAGO_ANOTHER_SITE_BUYING_FEEDBACK_SUBCATEGORY = 1023;
export const OSAGO_I_AM_JURIDICAL_PERSON_FEEDBACK_SUBCATEGORY = 1024;
export const OSAGO_OTHER_FEEDBACK_SUBCATEGORY = 1025;
export const OSAGO_CANT_FIND_TS_FEEDBACK_SUBCATEGORY = 1026;

export const OSAGO_OTHER_OBSOLETE1_SUBCATEGORY = 1050;

/* КАСКО */

export const KASKO_PAYMENT_PLOBLEMS_FEEDBACK_SUBCATEGORY = 2001;
export const KASKO_DELIVERY_TO_EMAIL_PLOBLEMS_FEEDBACK_SUBCATEGORY = 2002;
export const KASKO_RUNTIME_FEEDBACK_SUBCATEGORY = 2003;
export const KASKO_ENTERING_DATA_PROBLEMS_FEEDBACK_SUBCATEGORY = 2004;
export const KASKO_PREVIOUS_POLICY_OR_DATA_NOT_LOADED_FEEDBACK_SUBCATEGORY = 2005;
export const KASKO_DATA_CHANGED_FEEDBACK_SUBCATEGORY = 2006;
export const KASKO_WANT_TO_PAY_BY_CASH_FEEDBACK_SUBCATEGORY = 2007;
export const KASKO_CANT_FIND_TS_FEEDBACK_SUBCATEGORY = 2008;
export const KASKO_CANT_CALCULATE_SUBCATEGORY = 2009;
export const KASKO_PROGRAM_DOEST_ALLOW_FEEDBACK_SUBCATEGORY = 2010;
export const KASKO_OTHER_FEEDBACK_SUBCATEGORY = 2011;

/* Квартира */

export const FLAT_HAVE_A_QUESTION_FEEDBACK_SUBCATEGORY = 5001;
export const FLAT_CANT_GET_POLICY_FEEDBACK_SUBCATEGORY = 5002;
export const FLAT_WANT_TO_MAKE_CHANGES_IN_POLICY_SUBCATEGORY = 5003;
export const FLAT_PAYMENT_PROBLEMS_FEEDBACK_SUBCATEGORY = 5004;
export const FLAT_OTHER_FEEDBACK_SUBCATEGORY = 5005;

/* ВЗР */

export const VZR_HAVE_A_QUESTION_FEEDBACK_SUBCATEGORY = 45001;
export const VZR_CANT_GET_POLICY_FEEDBACK_SUBCATEGORY = 45002;
export const VZR_WANT_TO_MAKE_CHANGES_IN_POLICY_SUBCATEGORY = 45003;
export const VZR_PAYMENT_PROBLEMS_FEEDBACK_SUBCATEGORY = 45004;
export const VZR_OTHER_FEEDBACK_SUBCATEGORY = 45005;

/* Клещ  */

export const MITE_HAVE_A_QUESTION_FEEDBACK_SUBCATEGORY = 49001;
export const MITE_CANT_GET_POLICY_FEEDBACK_SUBCATEGORY = 49002;
export const MITE_WANT_TO_MAKE_CHANGES_IN_POLICY_SUBCATEGORY = 49003;
export const MITE_PAYMENT_PROBLEMS_FEEDBACK_SUBCATEGORY = 49004;
export const MITE_OTHER_FEEDBACK_SUBCATEGORY = 49005;

/* РФ */

export const RF_HAVE_A_QUESTION_FEEDBACK_SUBCATEGORY = 51001;
export const RF_CANT_GET_POLICY_FEEDBACK_SUBCATEGORY = 51002;
export const RF_WANT_TO_MAKE_CHANGES_IN_POLICY_SUBCATEGORY = 51003;
export const RF_PAYMENT_PROBLEMS_FEEDBACK_SUBCATEGORY = 51004;
export const RF_OTHER_FEEDBACK_SUBCATEGORY = 51005;

/* Личный кабинет */

export const LK_CHANGE_FIO_FEEDBACK_SUBCATEGORY = 9001;